// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-pages-features----dashboard-module---hero---RX6K-","text-container":"src-pages-features----dashboard-module---text-container---3CHyn","message":"src-pages-features----dashboard-module---message---TYnoZ","splash-image-container":"src-pages-features----dashboard-module---splash-image-container---1iBIF","splash-image":"src-pages-features----dashboard-module---splash-image---1LZSu","button":"src-pages-features----dashboard-module---button---3mu4_"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/dashboard.module.scss
// module id = 55
// module chunks = 168707334958949